import * as React from "react";
import { JSX } from "react/jsx-runtime";

const WhatsAppIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  const gradientId = React.useId(); // ensures uniqueness per component instance

  return (
    <svg
      width={200}
      height={200}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100 193.75C148.325 193.75 187.5 154.575 187.5 106.25C187.5 57.9251 148.325 18.75 100 18.75C51.6751 18.75 12.5 57.9251 12.5 106.25C12.5 121.943 16.6312 136.671 23.8655 149.406L12.5 193.75L58.2179 183.149C70.6336 189.909 84.8682 193.75 100 193.75ZM100 180.288C140.89 180.288 174.038 147.14 174.038 106.25C174.038 65.3597 140.89 32.2115 100 32.2115C59.1097 32.2115 25.9615 65.3597 25.9615 106.25C25.9615 122.038 30.9031 136.672 39.324 148.689L32.6923 173.558L57.9996 167.231C69.9335 175.466 84.4036 180.288 100 180.288Z"
        fill="#F2F2F2"
      />
      <path
        d="M175 100C175 141.421 141.421 175 100 175C84.201 175 69.543 170.115 57.4541 161.773L31.8182 168.182L38.536 142.99C30.0058 130.817 25 115.993 25 100C25 58.5786 58.5786 25 100 25C141.421 25 175 58.5786 175 100Z"
        fill={`url(#${gradientId})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100 187.5C148.325 187.5 187.5 148.325 187.5 100C187.5 51.6751 148.325 12.5 100 12.5C51.6751 12.5 12.5 51.6751 12.5 100C12.5 115.693 16.6312 130.421 23.8655 143.156L12.5 187.5L58.2179 176.899C70.6336 183.659 84.8682 187.5 100 187.5ZM100 174.038C140.89 174.038 174.038 140.89 174.038 100C174.038 59.1097 140.89 25.9615 100 25.9615C59.1097 25.9615 25.9615 59.1097 25.9615 100C25.9615 115.788 30.9031 130.422 39.324 142.439L32.6923 167.308L57.9996 160.981C69.9335 169.216 84.4036 174.038 100 174.038Z"
        fill="white"
      />
      <path
        d="M78.1251 59.3756C76.0447 55.197 72.8533 55.567 69.6292 55.567C63.8673 55.567 54.8828 62.4687 54.8828 75.3136C54.8828 85.8406 59.5216 97.364 75.1526 114.602C90.2378 131.238 110.059 139.844 126.514 139.551C142.969 139.258 146.354 125.098 146.354 120.316C146.354 118.196 145.039 117.139 144.133 116.851C138.525 114.16 128.183 109.146 125.83 108.204C123.477 107.262 122.248 108.536 121.484 109.229C119.35 111.263 115.12 117.256 113.672 118.604C112.224 119.952 110.064 119.27 109.166 118.76C105.859 117.434 96.8933 113.446 89.7467 106.518C80.9083 97.95 80.3896 95.0022 78.7244 92.3783C77.3922 90.2791 78.3698 88.9912 78.8576 88.4284C80.7619 86.2311 83.3913 82.8388 84.5705 81.153C85.7496 79.4672 84.8135 76.9077 84.2518 75.3136C81.8361 68.4577 79.7895 62.7185 78.1251 59.3756Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1={165.625}
          y1={43.75}
          x2={25}
          y2={175}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5BD066" />
          <stop offset={1} stopColor="#27B43E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default WhatsAppIcon;
